export class Role {

    public name = '';
  
    constructor() { }
  
}